module.exports = __webpack_public_path__ + "static/media/laptop.7b735b5e.gif";